import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AuthRequestDTO } from '../models/AuthRequestDTO';
import { AuthResponseDTO } from '../models/AuthResponseDTO';
import { UserDTO } from '../models/UserDTO';
import { Urls } from '../utilities/urls.component';
import { HttpHeadersService } from './http-headers.service';
@Injectable()
export class LoginService {
  profileData = new Subject();

  getUsersForSubscription(): Observable<any> {
    let data = new Observable<any>((observer) => {
      setTimeout(() => {
        observer.next(this.profileData);
      }, 0);
    });
    return data;
  }

  // API_ENDPOINT:string;
  constructor(private http: HttpClient, private headers: HttpHeadersService) {
    // this.API_ENDPOINT=localStorage.getItem("ENDPOINT");
  }

  login(request: AuthRequestDTO): Observable<AuthResponseDTO> {
    const url: string = Urls.API_ENDPOINT + Urls.AUTH.login;
    return this.http.post<AuthResponseDTO>(url, request, {
      headers: this.headers.getLoginHttpHeaders().headers, // Ensure this returns HttpHeaders
    });
  }
  logout() {
    var url: string = Urls.API_ENDPOINT + Urls.AUTH.logout;
    return this.http.get<AuthResponseDTO>(url, this.headers.getLoginHttpHeaders());
  }

  sendResetPasswordLink(request: AuthRequestDTO) {
    var url: string = Urls.API_ENDPOINT + Urls.AUTH.sendResetPasswordLink;
    return this.http.post<AuthResponseDTO>(url, request);
  }

  createNewPassword(request: AuthRequestDTO) {
    var url: string = Urls.API_ENDPOINT + Urls.AUTH.newPassword;
    return this.http.post<AuthResponseDTO>(url, request, this.headers.getLoginHttpHeaders());
  }

  getUserProfileInfo(userName: string, request: string) {
    var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.profileInfo + userName;
    return this.http.post<UserDTO>(url, request, this.headers.getCommonHttpHeaders());
  }

  validateToken(id: string, token: string, type: string) {
    var url: string = Urls.API_ENDPOINT + Urls.AUTH.validateToken + 'id=' + id + '&token=' + token + '&type=' + type;
    // var url: string = Urls.API_ENDPOINT + Urls.AUTH.validateToken + "token=" + token + "&type=" + type;
    return this.http.get<UserDTO>(url, this.headers.getCommonHttpHeaders());
  }
  accessMultileOrganization(email: string) {
    var url: string = Urls.API_ENDPOINT + Urls.AUTH.accessorg + email;
    return this.http.get(url, this.headers.getCommonHttpHeaders());
  }
  versionHistory(userType: string) {
    var url: string = Urls.API_ENDPOINT + Urls.AUTH.versionHistory + userType;
    return this.http.get(url, this.headers.getCommonHttpHeaders());
  }
}
